// extracted by mini-css-extract-plugin
export default {"switch_theme_div":"SwitchTheme_switch_theme_div__7Aokz","btnD":"SwitchTheme_btnD__6j5Yd","btnL":"SwitchTheme_btnL__hr7-W"};